import React from 'react'
import { BrComponent } from '@bloomreach/react-sdk'
import { LayoutContext } from '../utility'
import { ProductProvider } from '../components/investmentProducts/ProductContext.jsx'

export const ProductLanding = ({ page }) => {
  return (
    <ProductProvider>
      <div className="investment-products">
        <div id="product-header-container">
          <BrComponent path="main" />
        </div>
        <div id="tabs-container">
          <div
            id="tab-placeholder-1"
            className={page.isPreview() ? 'u-flexGrow2' : ''}
          >
            <LayoutContext.Provider
              value={{
                container: '1',
              }}
            >
              <BrComponent path="tabOne" />
            </LayoutContext.Provider>
          </div>
          <div
            id="tab-placeholder-2"
            className={`u-hidden ${page.isPreview() ? 'u-flexGrow1' : ''}`}
          >
            <LayoutContext.Provider
              value={{
                container: '2',
              }}
            >
              <BrComponent path="tabTwo" />
            </LayoutContext.Provider>
          </div>
          <div
            id="tab-placeholder-3"
            className={`u-hidden ${page.isPreview() ? 'u-flexGrow1' : ''}`}
          >
            <LayoutContext.Provider
              value={{
                container: '3',
              }}
            >
              <BrComponent path="tabThree" />
            </LayoutContext.Provider>
          </div>
          <div
            id="tab-placeholder-4"
            className={`u-hidden ${page.isPreview() ? 'u-flexGrow1' : ''}`}
          >
            <LayoutContext.Provider
              value={{
                container: '4',
              }}
            >
              <BrComponent path="tabFour" />
            </LayoutContext.Provider>
          </div>
          <div
            id="tab-placeholder-5"
            className={`u-hidden ${page.isPreview() ? 'u-flexGrow1' : ''}`}
          >
            <LayoutContext.Provider
              value={{
                container: '5',
              }}
            >
              <BrComponent path="tabFive" />
            </LayoutContext.Provider>
          </div>
          <div
            id="tab-placeholder-6"
            className={`u-hidden ${page.isPreview() ? 'u-flexGrow1' : ''}`}
          >
            <LayoutContext.Provider
              value={{
                container: '6',
              }}
            >
              <BrComponent path="tabSix" />
            </LayoutContext.Provider>
          </div>
          <div
            id="tab-placeholder-7"
            className={`u-hidden ${page.isPreview() ? 'u-flexGrow1' : ''}`}
          >
            <LayoutContext.Provider
              value={{
                container: '7',
              }}
            >
              <BrComponent path="tabSeven" />
            </LayoutContext.Provider>
          </div>
          <div
            id="tab-placeholder-8"
            className={`u-hidden ${page.isPreview() ? 'u-flexGrow1' : ''}`}
          >
            <LayoutContext.Provider
              value={{
                container: '8',
              }}
            >
              <BrComponent path="tabEight" />
            </LayoutContext.Provider>
          </div>
        </div>
      </div>
    </ProductProvider>
  )
}
